import React from 'react';
import { format } from 'date-fns';
import { Text } from 'components';
import { theme } from 'lib';
import { DetailSection, DetailRow } from '../styles';

const GameInfo = ({ game }) => {
  return (
    <>
      <Text h4 bold marg="24px 0 16px">
        Game Information
      </Text>

      <DetailSection>
        <DetailRow>
          <Text b2 med col={theme.GREY_60}>
            Date & Time
          </Text>
          <Text b2 bold>
            {game.date ? format(new Date(game.date), "EEEE, MMMM dd, yyyy 'at' h:mm a") : 'TBD'}
          </Text>
        </DetailRow>

        {game.league && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              League
            </Text>
            <Text b2 bold>
              {game.league}
            </Text>
          </DetailRow>
        )}

        {game.sport && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Sport
            </Text>
            <Text b2 bold>
              {game.sport}
            </Text>
          </DetailRow>
        )}

        {(game.location || game.venue) && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Location
            </Text>
            <Text b2 bold>
              {game.location || game.venue}
            </Text>
          </DetailRow>
        )}

        {game.timezone && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Timezone
            </Text>
            <Text b2>{game.timezone}</Text>
          </DetailRow>
        )}

        {game.gameStatus && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Game Status
            </Text>
            <Text b2>{game.gameStatus}</Text>
          </DetailRow>
        )}

        {game.progress && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Progress
            </Text>
            <Text b2>{game.progress}</Text>
          </DetailRow>
        )}

        {game.createdAt && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Created At
            </Text>
            <Text b2>{format(new Date(game.createdAt), 'MMM dd, yyyy h:mm a')}</Text>
          </DetailRow>
        )}

        {game.updatedAt && (
          <DetailRow>
            <Text b2 med col={theme.GREY_60}>
              Last Updated
            </Text>
            <Text b2>{format(new Date(game.updatedAt), 'MMM dd, yyyy h:mm a')}</Text>
          </DetailRow>
        )}
      </DetailSection>
    </>
  );
};

export default GameInfo;
